"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _envManager = require("../utils/envManager");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var IcertisAuthPage = function IcertisAuthPage() {
  (0, _react.useEffect)(function () {
    var urlParams = new URLSearchParams(window.location.search);
    var icmBaseUrl = urlParams.get("icmBaseUrl");
    if (!icmBaseUrl) {
      Office.onReady(function () {
        var _Office$context$ui;
        if ((_Office$context$ui = Office.context.ui) !== null && _Office$context$ui !== void 0 && _Office$context$ui.messageParent) {
          Office.context.ui.messageParent(JSON.stringify({
            error: "Missing icmBaseUrl parameter"
          }));
        }
      });
      return;
    }
    var cleanIcmBaseUrl = icmBaseUrl.trim().replace(/\/$/, "");
    var webappBaseUrl = (0, _envManager.getEnv)("WEBAPP_API_BASE_URL");
    if (!webappBaseUrl) {
      Office.onReady(function () {
        var _Office$context$ui2;
        if ((_Office$context$ui2 = Office.context.ui) !== null && _Office$context$ui2 !== void 0 && _Office$context$ui2.messageParent) {
          Office.context.ui.messageParent(JSON.stringify({
            error: "WEBAPP_API_BASE_URL is not configured"
          }));
        }
      });
      return;
    }
    var addInUrl = new URL(window.location.href);
    addInUrl.search = "";
    addInUrl.searchParams.set("page", "icertisCallbackPage");
    var callbackUrl = addInUrl.toString();
    var authUrl = "".concat(cleanIcmBaseUrl, "/userinformation/getusertokens?redirectUrl=").concat(encodeURIComponent(callbackUrl));
    window.location.href = authUrl;
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      flexDirection: "column"
    },
    "data-sentry-component": "IcertisAuthPage",
    "data-sentry-source-file": "IcertisAuthPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: "Redirecting to Icertis authentication..."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      style: {
        fontSize: "14px",
        color: "#666",
        marginTop: "8px"
      },
      children: "Please complete authentication in this window."
    })]
  });
};
var _default = exports.default = IcertisAuthPage;